"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasDefinedDefault = void 0;
const attributeOptions_js_1 = require("../constants/attributeOptions.js");
const hasDefinedDefault = (attribute) => ['key', 'put', 'update'].some(mode => attribute[attributeOptions_js_1.$state].defaults[mode] !== undefined || attribute[attributeOptions_js_1.$state].links[mode] !== undefined);
exports.hasDefinedDefault = hasDefinedDefault;
